var _style, _switch;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAgePension = function SvgAgePension(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "age-pension_svg__Layer_2",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".age-pension_svg__st4{fill:#260046}.age-pension_svg__st5{fill:#fff}.age-pension_svg__st6{fill:#f5f5f5}")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "age-pension_svg__SVGID_1_",
    d: "M0 0h80v80H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#age-pension_svg__SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eaeaea",
    d: "M40 80c22.093 0 40-17.908 40-39.999C80 17.908 62.093 0 40 0S0 17.908 0 40.001C0 62.092 17.907 80 40 80"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M54.682 18.393c-4.425-3.415-10.735-1.561-12.962 3.173a23.79 23.79 0 01-3.986 5.975c-3.544 3.863-2.976 11.079 6.832 10.618a54.312 54.312 0 015.889.044c3.753.231 10.178.197 10.736-5.223.204-1.984-1.141-4.003-.999-5.842.26-3.382-1.16-7.783-5.51-8.745z",
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.09 41.314c-7.646 0-13.844 6.198-13.844 13.844h27.688c0-7.646-6.198-13.844-13.844-13.844",
    className: "age-pension_svg__st4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.897 32.706a8.215 8.215 0 1116.43 0 8.215 8.215 0 11-16.43 0",
    className: "age-pension_svg__st5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.213 37.709h-6.245v3.93a3.124 3.124 0 006.246 0v-3.93z",
    className: "age-pension_svg__st5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.203 41.736c.001-.033.01-.063.01-.097v-1.337a8.175 8.175 0 01-6.246 0v1.337c0 .033.009.063.009.097.978.338 2.022.529 3.114.529s2.136-.192 3.113-.529",
    className: "age-pension_svg__st6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea4403",
    d: "M49.069 37.782c-9.598 0-17.378 7.779-17.378 17.376h34.754c0-9.598-7.778-17.376-17.376-17.376"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.822 55.158L49.9 43.742l.295-.508 1.25-1.92-2.334.139-2.253-.01 1.115 1.791.295.508-.922 11.416z",
    className: "age-pension_svg__st4"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.988 33.256h-7.839v4.934a3.92 3.92 0 107.839 0v-4.934z",
    className: "age-pension_svg__st5"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.976 38.311c.001-.04.012-.079.012-.121v-1.677a10.263 10.263 0 01-3.919.776c-1.389 0-2.71-.278-3.92-.776v1.677c0 .042.012.081.013.121 1.226.423 2.537.664 3.907.664 1.37-.001 2.68-.241 3.907-.664",
    className: "age-pension_svg__st6"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.758 26.977c0-5.695 4.616-10.312 10.312-10.312 5.695 0 10.31 4.617 10.31 10.312 0 5.695-4.616 10.312-10.31 10.312-5.697-.001-10.312-4.618-10.312-10.312",
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#a9a9a9",
    d: "M27.1 24.358c-4.328 0-7.876 3.428-8.202 7.781a8.79 8.79 0 003.206-3.112 8.476 8.476 0 0011.188.074 8.912 8.912 0 002.026 4.12c.007-.14.01-.282.01-.424 0-4.66-3.684-8.439-8.228-8.439"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#ababab",
    d: "M50.057 16.667l.001.002c-5.765-1.165-13.468 5.406-11.261 13.259 7.43.231 11.719-4.921 13.53-8.273 1.474 2.355 3.741 4.83 7.047 5.66 1.078-7.296-2.526-11.118-9.317-10.648z",
    clipPath: "url(#age-pension_svg__SVGID_00000145775020392114982930000004795791585640370111_)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAgePension);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/age-pension.ddfa6af1fb4437e62ec49f1236de3361.svg";